(() => {
  const initTabs = (root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    if (!tabs.length || !panels.length) return;

    const activate = (next) => {
      tabs.forEach((tab) => {
        const selected = tab === next;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        const match = panel.id === next.getAttribute('aria-controls');
        panel.hidden = !match;
        if (match) playLoopVideos(panel);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let targetIndex = null;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = tabs.length - 1;
        if (targetIndex === null) return;
        event.preventDefault();
        tabs[targetIndex].focus();
        activate(tabs[targetIndex]);
      });
    });
  };

  const initGallery = (root) => {
    const slides = [...root.querySelectorAll('[data-gallery-index]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-goto]')];
    if (!slides.length || !thumbs.length) return;

    const show = (index) => {
      slides.forEach((slide) => {
        const on = Number(slide.dataset.galleryIndex) === index;
        slide.hidden = !on;
        slide.querySelectorAll('video').forEach((video) => {
          if (on) {
            video.muted = true;
            const play = video.play();
            if (play && typeof play.catch === 'function') play.catch(() => {});
          } else {
            video.pause();
          }
        });
      });
      thumbs.forEach((thumb) => {
        const active = Number(thumb.dataset.galleryGoto) === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        show(Number(thumb.dataset.galleryGoto));
      });
    });
  };

  const initShowMore = (root) => {
    const button = root.querySelector('[data-show-more]');
    const extra = root.querySelector('[data-show-more-target]');
    if (!button || !extra) return;

    button.addEventListener('click', () => {
      const expanded = extra.hasAttribute('hidden') === false;
      extra.toggleAttribute('hidden', expanded);
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      button.textContent = expanded
        ? button.dataset.moreLabel || '+ Show more'
        : button.dataset.lessLabel || '+ Show less';
    });
  };

  // Decorative loop playback is owned by holo-site-video.js (lazy + pause offscreen).
  // Callers: theme.liquid → holo-ui.js; tabs/gallery still call playLoopVideos(panel).
  // User: consolidate autoplay; stop eager preload=auto on all loops.
  const playLoopVideos = (root = document) => {
    if (window.__holoSiteVideo && typeof window.__holoSiteVideo.scan === 'function') {
      window.__holoSiteVideo.scan(root);
      return;
    }
    if (typeof window.__holoPlayLoopVideos === 'function') {
      window.__holoPlayLoopVideos();
    }
  };

  const initLoopVideos = () => {
    playLoopVideos();
    if (!initLoopVideos.bound) {
      document.addEventListener('shopify:section:load', () => playLoopVideos());
      document.addEventListener('shopify:section:select', () => playLoopVideos());
      initLoopVideos.bound = true;
    }
  };

  const initStickyCreate = () => {
    const sticky = document.querySelector('[data-holo-sticky-create]');
    if (!sticky) return;

    const heroCreate =
      document.querySelector('[data-holo-hero-create]')
      || document.querySelector('.holo-home-hero .holo-btn--primary');
    const finalCreate =
      document.querySelector('[data-holo-final-create]')
      || document.querySelector('.holo-home-final .holo-btn--primary');

    if (!heroCreate) {
      sticky.hidden = true;
      sticky.setAttribute('aria-hidden', 'true');
      sticky.classList.remove('is-visible');
      document.documentElement.classList.remove('holo-sticky-create-visible');
      return;
    }

    let heroVisible = true;
    let finalVisible = false;

    const sync = () => {
      const show = !heroVisible && !finalVisible;
      sticky.hidden = !show;
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('holo-sticky-create-visible', show);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === heroCreate) heroVisible = entry.isIntersecting;
          if (finalCreate && entry.target === finalCreate) finalVisible = entry.isIntersecting;
        });
        sync();
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -8% 0px',
      },
    );

    observer.observe(heroCreate);
    if (finalCreate) observer.observe(finalCreate);
    sync();
  };

  const boot = () => {
    document.querySelectorAll('[data-holo-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-holo-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-holo-show-more]').forEach(initShowMore);
    initLoopVideos();
    initStickyCreate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
